import React, { useState, useEffect, useRef } from "react";
import { Outlet, Navigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import { store } from "../Store/store";
import LeftMenuComponent from "../Components/Menu/LeftMenuComponent";
import { useNavigate } from "react-router-dom";
import { thunk_reset_user, thunk_set_user } from '../../src/Action/action';
import { connect } from 'react-redux';
import { set, useForm } from "react-hook-form";
import * as UserService from '../Services/User/UserService'
import * as AccountService from '../Services/Account/AccountService'
import toast from "react-hot-toast";
import { Toaster } from 'react-hot-toast';
import { useSelector, useDispatch } from 'react-redux';
import { setSelectedOrganization, setAvailableOrganizationData } from '../Action/action';
import { Check, CheckCircle, Eye, EyeOff, X } from 'lucide-react';
import "./DashboardLayout.css"
import { useLocation } from 'react-router-dom';
import logo from '../Images/metropolis-logo.png';
import NotificationPopUpComponent from "../Components/Notification/NotificationPopUpComponent";
import { GetNotificationDet_ByPartnerCode } from "../Services/Dashboard/DashboardService";
import * as PartnerService from '../Services/Partner/PartnerService'
import { FaExclamationCircle, FaExclamationTriangle, FaUserCheck, FaUsers } from "react-icons/fa";
import { HitechSettings } from "../Common/CommonVariables";
import TourProvider from "../Providers/Tour Provider/TourProvider";

function DashboardLayout(props) {
    const [menuStyle, setMenuStyle] = useState("navbar-nav sidebar-menucolor sidebar sidebar-dark accordion toggled");
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [showProfileModal, setShowProfileModal] = useState(false);
    const [showChangePasswordModal, setShowChangePasswordModal] = useState(false);

    const [isLiftsidebar, setIsLiftsidebar] = useState(true);

    const navigate = useNavigate();

    const { register: registerProfile, handleSubmit: handleProfileSubmit,reset: resetProfile, } = useForm();
    const { register: registerPassword, watch, handleSubmit: handlePasswordSubmit, reset: resetPassword, formState: { errors } } = useForm();



    const userInfo = store.getState();
    const isAuthenticated = userInfo?.isAuthenticated || false;
    const userData = userInfo?.userData || {};

    const currentYear = new Date().getFullYear();

    const [OrganizationData, setOrganizationData] = useState([]);

    const dispatch = useDispatch();
    const selectedOrg = useSelector((state) => state.selectedOrganization);
    const userDetails = userInfo?.userData;

    const availableOrganizationData = useSelector((state) => state.availableOrganizationData);

    const selectRef = useRef();
    const [isLoggingOut, setIsLoggingOut] = useState(false);
  
    const [showOldPassword, setShowOldPassword] = useState(false);
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);

    const [selectedNotification, setSelectedNotification] = useState(null);
    const [notificationModalStatus, setNotificationModalStatus] = useState(false)
    const [allNotifications, setAllNotifications] = useState([]);

    const [showChangeUserSubMenu, setShowChangeUserSubMenu] = useState(false)
    const [partnerUserRoleList, setPartnerUserRoleList] = useState(null)
    const [partnerExtensionList, setPartnerExtensionList] = useState([]);
    const [showSwitchUserConfirmModal, setShowSwitchUserConfirmModal] = useState(false);
    const [showLoggedInAsUserModal, setShowLoggedInAsUserModal] = useState(false);
    const [loadingSwitch, setLoadingSwitch] = useState(false);

    const [loggedInExtension, setLoggedInExtension] = useState(null);
    const [countdown, setCountdown] = useState(5);

    useEffect(() => {
    if (sessionStorage.getItem("showLoggedInAsUserModal") === "true") {
        setShowLoggedInAsUserModal(true);
        sessionStorage.removeItem("showLoggedInAsUserModal"); 
    }
}, []);

    useEffect(() => {
        if (userData?.Partner_Code) {
            PartnerService.GetPartnerExtensionList(
            userData.Parent_Partner_Code,
            userData.UserId
            )
            .then(({ data }) => {
                if (data.IsSuccess) {
                setPartnerExtensionList(data.Data);
                } else {
                    
                }
            })
            .catch(() => {}
                // toast.error("Something went wrong loading users")
        );
        }
    }, [userData.Partner_Code, userData.Parent_Partner_Code, userData.UserId]);


    const location = useLocation();

    useEffect(()=>{
        PartnerService.GetPartnerUserDependedFeildDataList(userData.Partner_Code)
        .then(({data})=>{
            if(data.IsSuccess){
                setPartnerUserRoleList(data.Data)
            }else{
                setPartnerUserRoleList(null)
            }
        }).catch(()=>toast.error("Something went wrong."))
    }, [])

    const fetchNotificationDet_ByPartnerCode = () =>{
        GetNotificationDet_ByPartnerCode(userInfo.userData?.Partner_Code)
        .then(({ data }) => {
            if (data.IsSuccess) {
                setAllNotifications(data.Data)
            }
            else {
                setAllNotifications([])
            }
        })
            .catch(() => toast.error("Something went wrong."))
            .finally(() => {});
    }
  
    useEffect(() => {
        if (!isLoggingOut && userData.Partner_Code && userInfo.Partner_Account_Details!=null && (!availableOrganizationData || availableOrganizationData.length === 0 )) {
            GetOrganizationListByAccountCode();
        }
    }, [availableOrganizationData]);

    useEffect(() => {
        if (userInfo?.Partner_Account_Details) {
            fetchNotificationDet_ByPartnerCode();
        }
    }, []);

    useEffect(() => {
        if (selectedNotification) {
            setNotificationModalStatus(true);
        }
    }, [selectedNotification]);

    const Logout = () => {
        setIsLoggingOut(true);
        props.dispatch(thunk_reset_user({}));
        sessionStorage.clear()
        navigate("/");
    };

    const LogoutAsPartner = () => {
        const payload = {
        Parent_UserId: parseInt(userData?.UserId),
        Child_RoleId: parseInt(13),
        Child_Partner_Code: null,
        };

        UserService.ValidateSalesAdminSwitchUserLogin(payload)
        .then(({ data }) => {
            if (data.IsSuccess) {
            //debugger;
            toast.success("Logged in as Sales-Admin");
            props.dispatch(thunk_reset_user([]));
            props.dispatch(thunk_set_user(data));
            // setShowChangeUserSubMenu(false);
            navigate('/dashboard');
            // setShowLoggedInAsUserModal(true)
            // let counter = 5;
            // const interval = setInterval(() => {
            //     counter -= 1;
            //     setCountdown(counter);
            //     if (counter === 0) {
            //         clearInterval(interval);
            //         window.location.reload();
            //     }
            // }, 1000);
            setShowSwitchUserConfirmModal(true);
            } else {
            toast.error(data.ResponseMessage || "Failed to login as partner");
            }
        })
        .catch((error) => {toast.error("Something went wrong");})
        .finally()
    };

    const toggleMenu = () => {
        setIsLiftsidebar(!isLiftsidebar);
        setMenuStyle((prevStyle) =>
            prevStyle.includes("toggled") ? "navbar-nav sidebar-menucolor sidebar sidebar-dark accordion" : "navbar-nav sidebar-menucolor sidebar sidebar-dark accordion toggled"
        );
    };

    const toggleMobileMenu = () => {
        setMenuStyle((prevStyle) =>
            prevStyle.includes("toggled") 
                ? "navbar-nav sidebar-menucolor sidebar sidebar-dark accordion"   // open the sidebar
                : "navbar-nav sidebar-menucolor sidebar sidebar-dark accordion toggled" // close it
        );
    };

    const handleOrgChange = (e) => {
        const selected = availableOrganizationData.find(item => item.MHL_Org_Id__c === e.target.value);
        dispatch(setSelectedOrganization(selected));

    };

    const GetOrganizationListByAccountCode = () => {
        if(userData.Partner_Code === undefined || userData.Partner_Code === null || userData.Partner_Code === "")
            return;
        AccountService.GetOrganizationListByAccountCode(userData.Partner_Code).then(({ data }) => {
            if (data.IsSuccess) {
                setOrganizationData(data.Data); 
                dispatch(setAvailableOrganizationData(data.Data)); 

                const primaryOrg = data.Data.find(item => item.MHL_Primary__c === true);
                if (primaryOrg) {
                    dispatch(setSelectedOrganization(primaryOrg));
                }

            } else {
                setOrganizationData([]);
                dispatch(setAvailableOrganizationData([]));  
            }
        })
        .catch(() => toast.error("Something went wrong."));
    }

    const handleProfileClose = () => { setShowProfileModal(false); setDropdownOpen(false); };
    const handleChangePasswordClose = () => { setShowChangePasswordModal(false); resetPassword(); setDropdownOpen(false); };

    const onChangePasswordSubmit = (profileData) => {
        if (profileData.OldPassword != userData.Password) {
            toast.error("Old Password does not match")
            return;
        }
        if (userData.Password == profileData.NewPassword) {
            toast.error("Old/New Password can't be same")
            return;
        }

        UserService.UpdateUserDetail(profileData.EmailId, btoa(profileData.NewPassword)).then(({ data }) => {
            if (data.IsSuccess) {
                setIsLoggingOut(true);
                toast.success("User Password Updated successfully")
                props.dispatch(thunk_reset_user({}));
                navigate("/");
            } else {

            }
        })
            .catch(() =>{
                toast.error("Something went wrong.")}
            ).finally(() => { }
                //setLoading(false)
            );
    };

    if (!isAuthenticated) {
        return <Navigate to="/login" />;
    }

    const passwordValidation = {
        required: "New Password is required",
        minLength: { value: 8, message: "Minimum 8 characters" },
        maxLength: { value: 12, message: "Maximum 12 characters" },
        pattern: {
            value: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[#?!@$%^&*-])(?!.*\s)[A-Za-z\d#?!@$%^&*-]{8,12}$/,
            message: "Must contain uppercase, lowercase, a number, no spaces and one special characters(#?!@$%^&*-)",
        },
    };

    const handleNotificationClick = (rec) =>{
        setSelectedNotification(rec);
    }

    const handleModalClose = () => {
        setNotificationModalStatus(false);
        setSelectedNotification(null);
    }

   const validateCrossUser = (extension) => {
    setLoggedInExtension({
        Parent_UserId: parseInt(userData.UserId),
        Child_RoleId: parseInt(extension.RoleId),
        Parent_Partner_Code: extension.Parent_Partner_Code,
        Child_Partner_Code: extension.Child_Partner_Code,
        Role_Name: extension.Role_Name
    });
    setShowSwitchUserConfirmModal(true);
};


    const handle_LoginAsSelfBtn_Click = () => {
    setLoggedInExtension({
        Parent_UserId: parseInt(userData.UserId),
        Child_RoleId: parseInt(userData.Parent_RoleId),
        Parent_Partner_Code: userData.Parent_Partner_Code,
        Child_Partner_Code: userData.Parent_Partner_Code,
        Role_Name: userData.Role_Name
    });
    setShowSwitchUserConfirmModal(true);
};



    const ValidateCrossUserApiCall = (payload) =>{

        UserService.ValidateCrossUser(payload)
        .then(({data}) => {
            if(data.IsSuccess) {
                // toast.success("Switching user");
                props.dispatch(thunk_reset_user([]));
                props.dispatch(thunk_set_user(data));
                setShowChangeUserSubMenu(false);
                navigate('/dashboard');
                setShowLoggedInAsUserModal(true)
                // setTimeout(() => {
                //     window.location.reload()
                // }, 5000);

                let counter = 5;
                const interval = setInterval(() => {
                    counter -= 1;
                    setCountdown(counter);
                    if (counter === 0) {
                        clearInterval(interval);
                        window.location.reload();
                    }
                }, 1000);

            } else {
                toast.error(data.ResponseMessage || "Failed to switch user");
            }
        })
        .catch(() => toast.error("Something went wrong"))
        .finally()
    }

     const getInitials = (firstName, lastName) => {
        return `${firstName?.charAt(0) || ''}${lastName?.charAt(0) || ''}`.toUpperCase();
    };

    const currentBaseUrl = window.location.origin;

    return (
        <div id="page-top" >
            <div id="wrapper">
                <LeftMenuComponent ToggleMenu={toggleMenu} ToggleMobileMenu={toggleMobileMenu} MenuStyle={menuStyle} isLeftsidebar={isLiftsidebar} />
                <Toaster position="top-center" reverseOrder={false} />
                {/* Add one dropdown() */}
                <div id="content-wrapper" className="d-flex flex-column" style={{ overflow: "hidden" }}>
                    <div id="content" style={{ minHeight: "130vh" }}>

                        <nav className="navbar navbar-expand navbar-light bg-white topbar mb-2 static-top shadow d-flex justify-content-between">
                            <button className="btn hamburger-menu d-md-none rounded-circle ml-2" onClick={toggleMobileMenu}>
                                <i className="fa fa-bars"></i>
                            </button>

                        <div className="d-flex justify-content-between align-items-center user-icon-wrapper">
                            <div className="d-none d-sm-block">
                          {/* &nbsp;&nbsp;  {userInfo.Partner_Account_Details && userInfo.Partner_Account_Details.MHL_Status__c && (
                                <span  style={{ color: '#0d8145', fontWeight: 'bold' }}>  {userInfo.Partner_Account_Details.Name} </span>
                                        )} */}
                                        {isLiftsidebar && (
                            <div className="sidebar-brand d-flex justify-content-center align-items-center custom-sidebar-brand">
                                                {/* <div className="sidebar-brand d-flex align-items-center"> */}
                                                <button
                                                    onClick={toggleMenu}
                                                    className="btn btn-success  d-flex align-items-center justify-content-center"
                                                    style={{
                                                        width: "48px",
                                                        height: "48px",
                                                        padding: "2px", // Added padding to the button
                                                        margin: "5px", // Added padding to the button
                                                        // backgroundColor: "#2ecc71", // Match Metropolis green
                                                        border: "none",
                                                        // boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                                                        background: "#ffffff00"
                                                    }}
                                                >
                                                    <i className="fa fa-bars text-success"></i>
                                                </button>
                                                
                                            </div>
                                        )}
                                      
                            </div>

                        <ul className="navbar-nav d-flex align-items-center">
                        <div> 
                            {userInfo.Partner_Account_Details && userInfo.Partner_Account_Details.MHL_Status__c && (
                            //  <> <label className="dropdown pt-3 mx-0">Select Org:</label>
                                <li className="nav-item dropdown mx-2">
                                    {/* Select Org:  */}
                                <select ref={selectRef} onChange={handleOrgChange} className="form-select org-select" value={selectedOrg?.MHL_Org_Id__c || ''}>
                                    <option value="">Select Organization</option>
                                    {availableOrganizationData.map((item) => (
                                        <option key={item.MHL_Org_Id__c} value={item.MHL_Org_Id__c}>
                                            {item.MHL_Organization_Name}
                                        </option>
                                    ))}
                                </select>
                                    {/* <select ref={selectRef} className="form-select" style={{ minWidth: '250px' }}>
                                        <option value=""> Select Organization </option>
                                        {OrganizationData.map((item) => <option key={item.MHL_Organization_Name} value={item.MHL_Org_Id__c}>{item.MHL_Organization_Name}</option>)}

                                    </select> */}
                                </li>
                                // </>
                            )}
                            </div>
                                
                                <div>
                                <li
                                    className="nav-item dropdown no-arrow "
                                    onMouseEnter={() => setDropdownOpen(true)}
                                    onMouseLeave={() => setDropdownOpen(false)}
                                    onClick={() => setDropdownOpen(prev => !prev)}
                                >
                                    <div className="nav-link dropdown-toggle btn">
                                        <span className="mr-2 d-none d-lg-inline text-dark small">
                                            {userData.FirstName} {userData.LastName}
                                        </span>
                                        {/* <img className="img-profile rounded-circle" src="/img/undraw_profile.svg" alt="User" /> */}
                                        <i className="fas fa-user-circle fa-2x text-muted"></i>
                                        <i className="fas fa-caret-down ml-2 text-dark"></i>
                                    </div>
                                    {dropdownOpen && (
                                        <div className="dropdown-menu dropdown-menu-right shadow animated--grow-in show border rounded dropdown-menu-wrapper" aria-labelledby="userDropdown" style={{maxWidth: '325px'}} onClick={(e) => e.stopPropagation()}>
                                            <button className="dropdown-item" onClick={() => setShowProfileModal(true)}>
                                                <i className="fas fa-user fa-sm fa-fw mr-2 "></i>
                                                Profile
                                            </button>

                                        {/* {userData?.Role_Name === "Sales-Admin" && !userData?.Partner_Code && */}
                                            <button className="dropdown-item" onClick={() => setShowChangePasswordModal(true)}>
                                                <i className="fas fa-cogs fa-sm fa-fw mr-2 "></i>
                                                Change Password
                                            </button>
                                        {/* } */}

                                        {userData.Is_Parent && partnerExtensionList?.length > 0 && (
                                            <div className="switch-user-submenu">
                                                <div 
                                                className={`switch-user-menu-portal switch-user-menu-active`}
                                                >
                                                <div className="switch-user-header">
                                                    <h6 className="switch-user-title">Switch User</h6>
                                                </div>

                                                <div className="switch-user-primary mt-2">
                                                    <button
                                                    type="button"
                                                    onClick={handle_LoginAsSelfBtn_Click}
                                                    className="switch-user-item"
                                                    title={`${userData.FirstName} ${userData.LastName}`}
                                                    disabled={userData.Parent_Partner_Code === userData.Partner_Code}
                                                    >
                                                    <div className="switch-user-avatar">
                                                        {getInitials(userData.FirstName)}
                                                    </div>
                                                    <div className="switch-user-info">
                                                        <div className="switch-user-name">
                                                        {userData.FirstName} {userData.LastName}
                                                        </div>
                                                        <div className="switch-user-role">Primary Account</div>
                                                    </div>
                                                    {userData.Parent_Partner_Code === userData.Partner_Code && (
                                                        <span className="switch-user-current-badge">Current</span>
                                                    ) }
                                                    </button>
                                                </div>

                                                <div className="dropdown-divider"></div>

                                                {/* <div className="switch-user-others">
                                                    {partnerExtensionList?.length > 0 ? (
                                                    partnerExtensionList.map((extension) => {
                                                         const isCurrent = extension.Child_Partner_Code === userData.Partner_Code;

                                                         return(
                                                        <button
                                                        key={`ext-${extension.Id}`}
                                                        className="switch-user-item"
                                                        onClick={() => validateCrossUser(extension)}
                                                        type="button"
                                                        disabled={isCurrent}
                                                        title={`${extension.Child_Partner_Name}`}
                                                        >
                                                        <div className="switch-user-avatar">
                                                            {getInitials(extension.Child_Partner_Name)}
                                                        </div>
                                                        <div className="switch-user-info">
                                                            <div className="switch-user-name">
                                                            {extension.Child_Partner_Name}
                                                            </div>
                                                            <div className="switch-user-role">
                                                            {extension.Child_Partner_Code} - {extension.Role_Name}
                                                            </div>
                                                        </div>

                                                    {isCurrent && (
                                                        <span className="switch-user-current-badge">Current</span>
                                                    )}
                                                        </button>
                                                    )
                                                    })
                                                    ) : (
                                                    <div className="switch-user-empty">
                                                        <div className="switch-user-empty-icon">
                                                        <i className="fas fa-users"></i>
                                                        </div>
                                                        <div>No extended users available</div>
                                                    </div>
                                                    )}
                                                </div> */}

                                                <div className="switch-user-others">
                                                    {partnerExtensionList?.length > 0 ? (
                                                        [...partnerExtensionList]
                                                        .sort((a, b) =>
                                                            a.Child_Partner_Code === userData.Partner_Code
                                                            ? -1
                                                            : b.Child_Partner_Code === userData.Partner_Code
                                                            ? 1
                                                            : 0
                                                        )
                                                        .map((extension) => {
                                                            const isCurrent = extension.Child_Partner_Code === userData.Partner_Code;

                                                            return (
                                                            <button
                                                                key={`ext-${extension.Id}`}
                                                                className="switch-user-item"
                                                                onClick={() => validateCrossUser(extension)}
                                                                type="button"
                                                                disabled={isCurrent}
                                                                title={`${extension.Child_Partner_Name}`}
                                                            >
                                                                <div className="switch-user-avatar">
                                                                {getInitials(extension.Child_Partner_Name)}
                                                                </div>

                                                                <div className="switch-user-info">
                                                                <div className="switch-user-name">
                                                                    {extension.Child_Partner_Name}
                                                                </div>
                                                                <div className="switch-user-role">
                                                                    {extension.Child_Partner_Code} - {extension.Role_Name}
                                                                </div>
                                                                </div>

                                                                {isCurrent && (
                                                                <span className="switch-user-current-badge">Current</span>
                                                                )}
                                                            </button>
                                                            );
                                                        })
                                                    ) : (
                                                        <div className="switch-user-empty">
                                                        <div className="switch-user-empty-icon">
                                                            <i className="fas fa-users"></i>
                                                        </div>
                                                        <div>No extended users available</div>
                                                        </div>
                                                    )}
                                                    </div>

                                                </div>
                                            </div>
                                        )}

                                            <div className="dropdown-divider"></div>

                                            <button className="dropdown-item" onClick={Logout}>
                                                <i className="fas fa-sign-out-alt fa-sm fa-fw mr-2"></i>
                                                Logout
                                            </button>
                                            {userData?.Role_Name === "Sales-Admin" && userData?.Partner_Code &&
                                             <button className="dropdown-item" onClick={LogoutAsPartner}>
                                                <i className="fas fa-sign-out-alt fa-sm fa-fw mr-2"></i>
                                                Logout Current Partner
                                            </button>
                                            }
                                        </div>
                                    )}
                                </li>
                                </div>
                                </ul>
                            </div>
                        </nav>

                        {location.pathname === '/dashboard' &&
                            userInfo?.Partner_Account_Details &&
                            allNotifications &&
                            allNotifications.find((n) => n.Is_Marquee_Notification) && (() => {
                                const marqueeNotification = allNotifications.find((n) => n.Is_Marquee_Notification);
                                return (
                                    <div
                                        style={{ cursor: 'pointer' }}
                                        onClick={() => {
                                            // //console.log("Marquee clicked:", marqueeNotification.id);
                                            handleNotificationClick(marqueeNotification);
                                        }}
                                    >
                                        <marquee behavior="scroll" direction="left" scrollAmount="5">
                                            {marqueeNotification.Title}
                                        </marquee>
                                    </div>
                                );
                            })()}

                            {userData.Role_Name === "Sales-Admin" && userData.Partner_Code &&
                                <div className="marquee-container">
                                    <marquee behavior="scroll" direction="left" scrollAmount="5">
                                        <p className="marquee-text"> You have logged in as: {userData.Partner_Code} </p>
                                    </marquee>
                                </div>
                            }

                        <div className="container-fluid">
                            <Outlet />
                        </div>
                    </div>

                    <footer className="sticky-footer bg-white text-success">
                        <div className="container my-auto">
                            <div className="copyright text-center my-auto">
                                {/* <span>Copyright &copy; MHL 2024</span> */}
                                {/* <span>Copyright &copy; MHL {currentYear}</span> */}
                                {currentBaseUrl ===  HitechSettings.baseUrl
                                ?
                                <span>&copy; {currentYear} Hitech Diagnostic Healthcare Limited India, All Rights Reserved.</span>
                                :
                                <span>&copy; {currentYear} Metropolis Healthcare Limited India, All Rights Reserved.</span>
                                }
                            </div>
                        </div>
                    </footer>
                </div>
            </div>

            {/* Profile Modal */}
            {showProfileModal && (
                <div className="modal-backdrop">
                    <div className="modal fade show d-block" tabIndex="-1" role="dialog">
                        <div className="modal-dialog modal-l" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">Profile 
                                    {userInfo.Partner_Account_Details && userInfo.Partner_Account_Details.MHL_Status__c && (
                                        <span  style={{ color: 'red' }}> - {userInfo.Partner_Account_Details.Name} ({userInfo.Partner_Account_Details.MHL_Client_Code__c}) </span>
                                        )} </h5>
                                    <button type="button" className="btn-close" onClick={handleProfileClose}></button>
                                </div>
                                <div className="modal-body">
                                    <form>
                                        <div className="row">
                                            <div className="col-md-12 mb-2">
                                                <label className="fw-bold required mb-0-5">Name</label>
                                                <input type="text" className="form-control" value={`${userData.FirstName} ${userData.LastName}`} disabled {...registerProfile("FirstName")} />
                                            </div>

                                            <div className="col-md-12 mb-2">
                                                <label className="fw-bold required mb-0-5">Email</label>
                                                <input type="email" className="form-control" value={userData.EmailId} disabled {...registerProfile("EmailId")} />
                                            </div>
                                            <div className="col-md-12 mb-2">
                                                <label className="fw-bold required mb-0-5">Role Name</label>
                                                <input type="text" className="form-control" value={userData.Role_Name} disabled {...registerProfile("RoleName")} />
                                            </div>
                                        </div>
                                    </form>
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-danger" onClick={handleProfileClose}>Close</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Change Password Modal */}
            {showChangePasswordModal && (
                <div className="modal-backdrop w-100">
                    <div className="modal fade show d-block" tabIndex="-1" role="dialog">
                        <div className="modal-dialog modal-l" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">Change Password</h5>
                                    <button type="button" className="btn-close" onClick={handleChangePasswordClose}></button>
                                </div>
                                <div className="modal-body">
                                    <form onSubmit={handlePasswordSubmit(onChangePasswordSubmit)}>
                                        <div className="row">
                                            <div className="col-md-12 mb-2">
                                                <label className="fw-bold required mb-0-5">Mobile No</label>
                                                <input type="text" className="form-control" value={userData.MobileNo} disabled {...registerPassword("MobileNo")} />
                                            </div>
                                            <div className="col-md-12 mb-2">
                                                <label className="fw-bold required mb-0-5">Email</label>
                                                <input type="email" className="form-control" value={userData.EmailId} disabled {...registerPassword("EmailId")} />
                                            </div>
                                            {/* Old Password */}
                                            <div className="col-md-12 mb-2" >
                                                <label className="fw-bold required mb-0-5">Old Password</label>
                                                <div style={{ position: "relative" }}>
                                                <input
                                                type={showOldPassword ? "text" : "password"}
                                                className="form-control"
                                                {...registerPassword("OldPassword", { required: "Old Password is required" })}
                                                style={{ paddingRight: "40px" }}
                                                />
                                                <button type="button" className="btn btn-sm position-absolute top-50 end-0 me-3"
                                                style={{ background: "transparent", border: "none", transform: "translateY(-50%)"}}  onClick={() => setShowOldPassword(!showOldPassword)}>
                                                {showOldPassword ? <Eye size={18} /> : <EyeOff size={18} /> }
                                                </button>
                                                </div>
                                                {errors.OldPassword && <p className="text-danger">{errors.OldPassword.message}</p>}
                                            </div>

                                            {/* New Password */}
                                            <div className="col-md-12 mb-2" >
                                                <label className="fw-bold required mb-0-5">New Password</label>
                                                <div style={{ position: "relative" }}>
                                                <input
                                                    type={showNewPassword ? "text" : "password"}
                                                    className="form-control"
                                                    {...registerPassword("NewPassword", passwordValidation)}
                                                    style={{ paddingRight: "40px" }}
                                                />
                                                <button
                                                    type="button"
                                                    className="btn btn-sm position-absolute top-50 end-0 me-3"
                                                    style={{ background: "transparent", border: "none",transform: "translateY(-50%)" }}
                                                    onClick={() => setShowNewPassword(!showNewPassword)}
                                                >
                                                    {showNewPassword ? <Eye size={18} /> : <EyeOff size={18} /> }
                                                </button>
                                                </div>
                                                {errors.NewPassword && <p className="text-danger">{errors.NewPassword.message}</p>}
                                            </div>

                                            {/* Confirm Password */}
                                            <div className="col-md-12 mb-2" >
                                                <label className="fw-bold required mb-0-5">Confirm Password</label>
                                                <div style={{ position: "relative" }}>
                                                <input
                                                    type={showConfirmPassword ? "text" : "password"}
                                                    className="form-control"
                                                    {...registerPassword("ConfirmPassword", {
                                                    required: "Confirm Password is required",
                                                    validate: (value) =>
                                                        value === watch("NewPassword") || "Passwords do not match",
                                                    })}
                                                    style={{ paddingRight: "40px" }}
                                                />
                                                <button
                                                    type="button"
                                                    className="btn btn-sm position-absolute top-50 end-0 me-3"
                                                    style={{ background: "transparent", border: "none", transform: "translateY(-50%)" }}
                                                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                                >
                                                    {showConfirmPassword ? <Eye size={18} /> : <EyeOff size={18} /> }
                                                </button>
                                                </div>
                                                {errors.ConfirmPassword && <p className="text-danger">{errors.ConfirmPassword.message}</p>}
                                            </div>
                                            {/* <div className="col-md-12 mb-2">
                                                <label className="fw-bold required mb-0-5">Old Password</label>
                                                <input type="text" className="form-control" {...registerPassword("OldPassword", { required: "Old Password is required" })} />
                                                {errors.OldPassword && <p className="text-danger">{errors.OldPassword.message}</p>}
                                            </div> */}
                                            {/* <div className="col-md-12 mb-2">
                                                <label className="fw-bold required mb-0-5">New Password</label>
                                                <input type="text" className="form-control" {...registerPassword("NewPassword", { required: "New Password is required" })} />
                                                {errors.NewPassword && <p className="text-danger">{errors.NewPassword.message}</p>}
                                            </div> */}
                                        </div>
                                        <div className="modal-footer">
                                            <button type="button" className="btn btn-danger" onClick={handleChangePasswordClose}>Close</button>
                                            <button type="submit" className="btn btn-primary">Update</button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {showSwitchUserConfirmModal && loggedInExtension && (
                <div className="modal-backdrop modal-backdrop-switch-user-modal">
                    <div className="modal fade show d-block" tabIndex="-1" role="dialog">
                    <div className="modal-dialog switch-user-modal" role="document">
                        <div className="modal-content modal-content-switch-user-modal">
                        <div className="modal-body text-white modal-body-switch-user-modal">
                            <div className="modal-title-switch-user-modal">
                                <div className="modal-icon-switch-user-modal">
                                    <FaExclamationTriangle size={28}/>
                                </div>
                                <h4>Are you sure?</h4>
                                <button className="btn modal-close-btn-switch-user-modal" onClick={() => setShowSwitchUserConfirmModal(false)} aria-label="Close">
                                    <X size={20}/>
                                </button>
                            </div>
                            <p className="modal-text-switch-user-modal fs-6">
                            You are about to switch to your partner account.  
                            Do you want to continue?
                            </p>
                        </div>
                        <div className="modal-footer-switch-user-modal">
                            <button
                            type="button"
                            className="btn btn-danger modal-btn-danger-switch-user-modal"
                            onClick={() => setShowSwitchUserConfirmModal(false)}
                            >
                            Cancel
                            </button>
                           <button
                            type="button"
                            className="btn btn-light modal-btn-switch-user-modal"
                            onClick={() => {
                                if (loggedInExtension) {
                                    ValidateCrossUserApiCall(loggedInExtension);
                                    setShowSwitchUserConfirmModal(false);
                                }
                            }}
                            disabled={loadingSwitch}
                            >
                                {loadingSwitch ? (
                                    <>
                                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                        Switching...
                                    </>
                                ) : (
                                    "Switch"
                                )}
                            </button>
                        </div>
                        </div>
                    </div>
                    </div>
                </div>
            )}


            {showLoggedInAsUserModal && loggedInExtension && (
                <div className="modal-backdrop modal-backdrop-logged-in-as">
                    <div className="modal fade show d-block" tabIndex="-1" role="dialog">
                        <div className="modal-dialog modal-sm" role="document">
                            <div className="modal-content modal-content-logged-in-as">
                                <div className="modal-body text-white modal-body-logged-in-as">
                                    <div className="success-icon-container">
                                        <Check size={42} className="text-success" />
                                    </div>
                                    <h4 className="modal-title-logged-in">Successfully Logged In as</h4>
                                    <div className="login-details">
                                        <div className="detail-item">
                                            <span className="detail-label">Partner Code</span>
                                            <span className="detail-value">{loggedInExtension.Child_Partner_Code}</span>
                                        </div>
                                        {loggedInExtension.Role_Name && (
                                            <div className="detail-item">
                                                <span className="detail-label">Role</span>
                                                <span className="detail-value">{loggedInExtension.Role_Name}</span>
                                            </div>
                                        )}
                                    </div>
                                    <p className="mt-3">The page will refresh in {countdown}</p>
                                </div>
                                {/* <div className="modal-footer-logged-in">
                                    <button type="button" className="btn modal-btn-logged-in-as" onClick={() => setShowLoggedInAsUserModal(false)}>
                                        Continue
                                    </button>
                                </div> */}
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Show Notification pop up on marquee click */}
            {selectedNotification && notificationModalStatus && (
                <NotificationPopUpComponent NotificationDet={selectedNotification} handleModalClose={handleModalClose} />
            )}
        </div>
    );
}

const mapStateToProps = state => ({
    data: state
});

export default connect(mapStateToProps)(DashboardLayout);

// import React, { useState, useEffect, useRef, useContext } from "react";
// import { Outlet, Navigate } from "react-router-dom";
// import "bootstrap/dist/css/bootstrap.min.css";
// import { store } from "../Store/store";
// import LeftMenuComponent from "../Components/Menu/LeftMenuComponent";
// import { useNavigate } from "react-router-dom";
// import { thunk_reset_user } from '../../src/Action/action';
// import { connect } from 'react-redux';
// import { useForm } from "react-hook-form";
// import * as UserService from '../Services/User/UserService'
// import * as AccountService from '../Services/Account/AccountService'
// import toast from "react-hot-toast";
// import { Toaster } from 'react-hot-toast';
// import { OrganizationContext } from '../Context/OrganizationContext';

// function DashboardLayout(props) {
//     const [menuStyle, setMenuStyle] = useState("navbar-nav sidebar-menucolor sidebar sidebar-dark accordion toggled");
//     const [dropdownOpen, setDropdownOpen] = useState(false);
//     const [showProfileModal, setShowProfileModal] = useState(false);
//     const [showChangePasswordModal, setShowChangePasswordModal] = useState(false);
//     const navigate = useNavigate();

//     const { register: registerProfile, handleSubmit: handleProfileSubmit } = useForm();
//     const { register: registerPassword, handleSubmit: handlePasswordSubmit, formState: { errors } } = useForm();

//     const userInfo = store.getState();
//     const isAuthenticated = userInfo?.isAuthenticated || false;
//     const userData = userInfo?.userData || {};

//     const currentYear = new Date().getFullYear();

//     const selectRef = useRef("");
//     const [OrganizationData, setOrganizationData] = useState([]);

//     const { organizations, selectedOrganizationId, setSelectedOrganizationId } = useContext(OrganizationContext);

//     useEffect(() => {
//         GetOrganizationListByAccountCode();
//     }, []);


//     const Logout = () => {
//         props.dispatch(thunk_reset_user({}));
//         navigate("/");
//     };

//     const toggleMenu = () => {
//         setMenuStyle((prevStyle) =>
//             prevStyle.includes("toggled") ? "navbar-nav sidebar-menucolor sidebar sidebar-dark accordion" : "navbar-nav sidebar-menucolor sidebar sidebar-dark accordion toggled"
//         );
//     };

//     const toggleMobileMenu = () => {
//         setMenuStyle((prevStyle) =>
//             prevStyle.includes("toggled1") ? "navbar-nav sidebar-menucolor sidebar sidebar-dark accordion" : "navbar-nav sidebar-menucolor sidebar sidebar-dark accordion toggled1"
//         );
//     };

//     const GetOrganizationListByAccountCode = () => {

//         AccountService.GetOrganizationListByAccountCode().then(({ data }) => {
//             if (data.IsSuccess) {
//                 setOrganizationData(data.Data)
//             } else {

//             }
//         })
//             .catch(() =>
//                 toast.error("Something went wrong.")
//             ).finally(() => { }
//                 //setLoading(false)
//             );
//     }


//     const handleProfileClose = () => setShowProfileModal(false);
//     const handleChangePasswordClose = () => setShowChangePasswordModal(false);

//     const onChangePasswordSubmit = (profileData) => {
//         //debugger;
//         if (profileData.OldPassword != userData.Password) {
//             toast.error("Old Password cannot match")
//             return;
//         }
//         if (userData.Password == profileData.NewPassword) {
//             toast.error("Old/New Password can't be same")
//             return;
//         }

//         UserService.UpdateUserDetail(profileData.EmailId, profileData.NewPassword).then(({ data }) => {
//             if (data.IsSuccess) {
//                 toast.success("User Password Updated successfully")
//                 props.dispatch(thunk_reset_user({}));
//                 navigate("/");
//             } else {

//             }
//         })
//             .catch(() =>
//                 toast.error("Something went wrong.")
//             ).finally(() => { }
//                 //setLoading(false)
//             );


//     };

//     if (!isAuthenticated) {
//         return <Navigate to="/login" />;
//     }

//     return (
//         <div id="page-top" >
//             <div id="wrapper">
//                 <LeftMenuComponent ToggleMenu={toggleMenu} MenuStyle={menuStyle} />
//                 <Toaster position="top-center" reverseOrder={false} />
//                 {/* Add one dropdown() */}
//                 <div id="content-wrapper" className="d-flex flex-column" style={{ overflow: "hidden" }}>
//                     <div id="content" style={{ minHeight: "140vh" }}>

//                         <nav className="navbar navbar-expand navbar-light bg-white topbar mb-4 static-top shadow">
//                             <button className="btn btn-link d-md-none rounded-circle mr-3" onClick={toggleMobileMenu}>
//                                 <i className="fa fa-bars"></i>
//                             </button>

//                             <ul className="navbar-nav ml-auto">

//                                 <li className="nav-item dropdown pt-3 mx-2">
//                                     <select ref={selectRef} className="form-select" style={{ minWidth: '250px' }} onChange={(e) => setSelectedOrganizationId(e.target.value)} value={selectedOrganizationId} >
//                                         <option value=""> Select Organization </option>
//                                         {organizations.map((item) => <option key={item.MHL_Organization_Name} value={item.MHL_Org_Id__c}>{item.MHL_Organization_Name}</option>)}

//                                     </select>
//                                 </li>
                                
//                                 <li
//                                     className="nav-item dropdown no-arrow"
//                                     onMouseEnter={() => setDropdownOpen(true)}
//                                     onMouseLeave={() => setDropdownOpen(false)}
//                                 >
//                                     <div className="nav-link dropdown-toggle btn">
//                                         <span className="mr-2 d-none d-lg-inline text-gray-600 small">
//                                             {userData.FirstName} {userData.LastName}
//                                         </span>
//                                         {/* <img className="img-profile rounded-circle" src="/img/undraw_profile.svg" alt="User" /> */}
//                                         <i className="fas fa-user-circle fa-2x"></i>
//                                         <i className="fas fa-caret-down ml-2"></i>
//                                     </div>
//                                     {dropdownOpen && (
//                                         <div className="dropdown-menu dropdown-menu-right shadow animated--grow-in show border rounded" aria-labelledby="userDropdown">
//                                             <button className="dropdown-item" onClick={() => setShowProfileModal(true)}>
//                                                 <i className="fas fa-user fa-sm fa-fw mr-2 text-gray-400"></i>
//                                                 Profile
//                                             </button>

//                                             <button className="dropdown-item" onClick={() => setShowChangePasswordModal(true)}>
//                                                 <i className="fas fa-cogs fa-sm fa-fw mr-2 text-gray-400"></i>
//                                                 Change Password
//                                             </button>

//                                             <div className="dropdown-divider"></div>

//                                             <button className="dropdown-item" onClick={Logout}>
//                                                 <i className="fas fa-sign-out-alt fa-sm fa-fw mr-2 text-gray-400"></i>
//                                                 Logout
//                                             </button>
//                                         </div>
//                                     )}
//                                 </li>
//                             </ul>
//                         </nav>

//                         <div className="container-fluid">
//                             <Outlet />
//                         </div>
//                     </div>

//                     <footer className="sticky-footer bg-white">
//                         <div className="container my-auto">
//                             <div className="copyright text-center my-auto">
//                                 {/* <span>Copyright &copy; MHL 2024</span> */}
//                                 <span>Copyright &copy; MHL {currentYear}</span>
//                             </div>
//                         </div>
//                     </footer>
//                 </div>
//             </div>

//             {/* Profile Modal */}
//             {showProfileModal && (
//                 <div className="modal-backdrop">
//                     <div className="modal fade show d-block" tabIndex="-1" role="dialog">
//                         <div className="modal-dialog modal-sm custom-modal-com" role="document">
//                             <div className="modal-content">
//                                 <div className="modal-header">
//                                     <h5 className="modal-title">Profile</h5>
//                                     <button type="button" className="btn-close" onClick={handleProfileClose}></button>
//                                 </div>
//                                 <div className="modal-body">
//                                     <form>
//                                         <div className="row">
//                                             <div className="col-md-12 mb-2">
//                                                 <label className="fw-bold required mb-0-5">Name</label>
//                                                 <input type="text" className="form-control" value={`${userData.FirstName} ${userData.LastName}`} disabled {...registerProfile("FirstName")} />
//                                             </div>

//                                             <div className="col-md-12 mb-2">
//                                                 <label className="fw-bold required mb-0-5">Email</label>
//                                                 <input type="email" className="form-control" value={userData.EmailId} disabled {...registerProfile("EmailId")} />
//                                             </div>
//                                             <div className="col-md-12 mb-2">
//                                                 <label className="fw-bold required mb-0-5">Role Name</label>
//                                                 <input type="text" className="form-control" value={userData.Role_Name} disabled {...registerProfile("RoleName")} />
//                                             </div>
//                                         </div>
//                                     </form>
//                                 </div>
//                                 <div className="modal-footer">
//                                     <button type="button" className="btn btn-danger" onClick={handleProfileClose}>Close</button>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             )}

//             {/* Change Password Modal */}
//             {showChangePasswordModal && (
//                 <div className="modal-backdrop">
//                     <div className="modal fade show d-block" tabIndex="-1" role="dialog">
//                         <div className="modal-dialog modal-sm custom-modal-com" role="document">
//                             <div className="modal-content">
//                                 <div className="modal-header">
//                                     <h5 className="modal-title">Change Password</h5>
//                                     <button type="button" className="btn-close" onClick={handleChangePasswordClose}></button>
//                                 </div>
//                                 <div className="modal-body">
//                                     <form onSubmit={handlePasswordSubmit(onChangePasswordSubmit)}>
//                                         <div className="row">
//                                             <div className="col-md-12 mb-2">
//                                                 <label className="fw-bold required mb-0-5">Mobile No</label>
//                                                 <input type="text" className="form-control" value={userData.MobileNo} disabled {...registerPassword("MobileNo")} />
//                                             </div>
//                                             <div className="col-md-12 mb-2">
//                                                 <label className="fw-bold required mb-0-5">Email</label>
//                                                 <input type="email" className="form-control" value={userData.EmailId} disabled {...registerPassword("EmailId")} />
//                                             </div>
//                                             <div className="col-md-12 mb-2">
//                                                 <label className="fw-bold required mb-0-5">Old Password</label>
//                                                 <input type="text" className="form-control" {...registerPassword("OldPassword", { required: "Old Password is required" })} />
//                                                 {errors.OldPassword && <p className="text-danger">{errors.OldPassword.message}</p>}
//                                             </div>
//                                             <div className="col-md-12 mb-2">
//                                                 <label className="fw-bold required mb-0-5">New Password</label>
//                                                 <input type="text" className="form-control" {...registerPassword("NewPassword", { required: "New Password is required" })} />
//                                                 {errors.NewPassword && <p className="text-danger">{errors.NewPassword.message}</p>}
//                                             </div>
//                                         </div>
//                                         <div className="modal-footer">
//                                             <button type="button" className="btn btn-danger" onClick={handleChangePasswordClose}>Close</button>
//                                             <button type="submit" className="btn btn-primary">Update</button>
//                                         </div>
//                                     </form>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             )}
//         </div>
//     );
// }

// const mapStateToProps = state => ({
//     data: state
// });

// export default connect(mapStateToProps)(DashboardLayout);